module.exports = __webpack_public_path__ + "img/image-thumb-17.c4a5e6a9.jpg";